// 组件对象，大写
import treeEdit from './treeEdit.vue'
export default treeEdit
